import React from 'react';
import MarkdownIt from 'markdown-it';

interface MarkdownRendererProps {
  content: string;
  className?: string;
}

const MarkdownRenderer: React.FC<MarkdownRendererProps> = ({ content, className = '' }) => {
  // Create markdown-it instance with options
  const md = new MarkdownIt({
    html: true,
    linkify: true,
    typographer: true,
    breaks: true,
  });
  
  // Convert markdown to HTML
  const htmlContent = md.render(content);
  
  return (
    <div className={`markdown-content ${className}`}>
      <div 
        className="markdown-rendered"
        dangerouslySetInnerHTML={{ __html: htmlContent }}
        style={{
          lineHeight: '1.6',
          fontSize: '1.1rem',
        }}
      />
    </div>
  );
};

export default MarkdownRenderer; 